/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 14:57:23
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 11:04:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/slice/index.ts
 */
import { combineReducers } from '@reduxjs/toolkit';
import reviewDetail from '../ProductReviewDetail/slice';
import reviewList from '../ProductReviewList/store';
import { EnumReducers } from './contants';
export { EnumReducers };
const salesChannelLegalReducer = combineReducers({
  [EnumReducers.reviewDetail]: reviewDetail,
  [EnumReducers.reviewList]: reviewList,
});
export default salesChannelLegalReducer;
